import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";

export class UpdateRouteBoundEquipmentViewComponent implements IController {

  route?: any;
  branchIds: string[];
  mainVehicleId: any;
  attachedVehicleId: any;
  isAttachmentRequired: boolean;
  onMainLogisticsVehicleSelect: Function;
  onAttachedLogisticsVehicleSelect: Function;

  public agentSelectionOptions: any;

  constructor() {
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('updateRouteBoundEquipmentView', {
    require: {
      form: '^form'
    },
    bindings: {
      route: '<?',
      branchIds: '<?',
      mainVehicleId: '<',
      attachedVehicleId: '<?',
      isAttachmentRequired: '<?',
      onMainLogisticsVehicleSelect: '&',
      onAttachedLogisticsVehicleSelect: '&'
    },
    template: require('./update-route-bound-equipment-view.html').default,
    controller: UpdateRouteBoundEquipmentViewComponent
  });
